import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import SettingsSection from '../SettingsSection';

const PlaceholderBox = styled(FlexColumn)`
  border: 1px dashed ${({ theme }) => theme.palette.common.gray8};
  border-radius: 6px;
  padding: 24px;
  gap: 4px;
`;

const RuntimeDebugPlaceholder = () => (
  <SettingsSection title="Debugging">
    <PlaceholderBox>
      <Typography sx={{ fontWeight: 'bold' }}>Coming soon</Typography>
      <Typography variant="body1">
        Runtime instances, recent activity, and logs will appear here to help
        you troubleshoot this runtime.
      </Typography>
    </PlaceholderBox>
  </SettingsSection>
);

export default RuntimeDebugPlaceholder;
